/*-----------------------------------------------------------------
- Contact info
-----------------------------------------------------------------*/
export default {
    branch_name      : 'Branch Name',
    branch_admin_name: 'Management',
    address          : 'Address',
    tel              : 'Phone',
    fax              : 'Fax',
    email            : 'Email',
    separator        : ':',
};
